import QuestionTypeRadioGroup from "pages/QuestionPage/questionCreation/QuestionTypeRadioGroup/QuestionTypeRadioGroup";

export default QuestionTypeRadioGroup;
